import { Children, isValidElement, type ReactNode } from 'react';

/**
 * Filter out invalid children from a React component.
 * @param children - children to filter
 * @returns filtered children
 */
export const onlyValidChildren = (children?: ReactNode): ReactNode => {
  return Children.toArray(children).filter(isValidElement);
};
